module.exports = __webpack_public_path__ + "static/media/error.7c9d533d.svg";